import { Injectable, inject } from '@angular/core';
import { Apollo, gql } from 'apollo-angular';
import { firstValueFrom } from 'rxjs';
import {
  CreateActivityLogMutation,
  CreateActivityLogMutationVariables,
  GetActivityLogQuery,
  GetActivityLogQueryVariables,
} from '../../generated/operations';
import { Activity_Log_Bool_Exp, Activity_Log_Insert_Input } from '@skychute/schema';

@Injectable({
  providedIn: 'root',
})
export class ActivityLogService {
  private apollo = inject(Apollo);


  async get(condition: Activity_Log_Bool_Exp): Promise<GetActivityLogQuery['activity_log']> {
    const resp = await firstValueFrom(
      this.apollo.query<GetActivityLogQuery, GetActivityLogQueryVariables>({
        query: GET_ACTIVITY_LOG,
        variables: { condition },
      }),
    );

    return resp.data.activity_log ?? [];
  }

  async create(input: Activity_Log_Insert_Input) {
    const resp = await firstValueFrom(
      this.apollo.mutate<CreateActivityLogMutation, CreateActivityLogMutationVariables>({
        mutation: CREATE_ACTIVITY_LOG,
        variables: { input },
      }),
    );

    return resp.data?.insert_activity_log_one?.id ?? '';
  }
}

const GET_ACTIVITY_LOG = gql`
  query getActivityLog($condition: activity_log_bool_exp!) {
    activity_log(where: $condition, order_by: { created_at: desc }) {
      id
      contact_id
      description
      title
      activity
      metadata
      created_at
      deal_id
    }
  }
`;

//
// Queries
//
const CREATE_ACTIVITY_LOG = gql`
  mutation createActivityLog($input: activity_log_insert_input!) {
    insert_activity_log_one(object: $input) {
      id
    }
  }
`;
